import React, { useState, useEffect } from 'react'
import _ from 'lodash'
import { Dropdown_s } from 'styles/input-styles'

interface NamedItemProps {
  attrs?: Function
  data: []
  default?: string
  disabled?: boolean
  field: string
  filter?: boolean
  options: string[]
  persist: Function
  className: string
  namedItem?: string
}

const NamedItemInput = (props: NamedItemProps) => {
  let namedItem: string = props.namedItem || (Array.isArray(props.field) ? props.field?.[1] : props.field)
  namedItem = namedItem.replace('NamedItem', '').toLowerCase()
  const [dirty, updateDirty] = useState<boolean>(false)
  const initialValue = _.get(props.data, props.field)
  const [val, updateVal] = useState<string | null>(initialValue || null)
  const options = props.options.map((option) => {
    return { label: option['code'], value: option[namedItem] }
  })

  if (dirty && props.default && initialValue === null) {
    updateDirty(false)
    updateVal(props.default)
    props.persist(props.default, props.field)
  }

  useEffect(() => {
    if (_.isNil(initialValue) && !_.isNil(val)) {
      updateVal(null)
    }
    if (!_.isNil(initialValue)) {
      updateVal(initialValue)
    }
  }, [initialValue])

  const attrs = (props.attrs && props.attrs(props.field)) || {}

  return (
    <span {...attrs}>
      <Dropdown_s
        className={props.className}
        disabled={props['disabled']}
        value={val || props.default}
        filter={props.filter || false}
        {...attrs}
        options={options}
        onChange={(e) => {
          updateDirty(false)
          updateVal(e.value)
          props.persist(e.value, props.field)
        }}
        onMouseDown={(e) => {
          if (!dirty && !props.disabled) updateDirty(true)
        }}
      />
    </span>
  )
}

export default NamedItemInput
